import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ZoneService} from '../../../zone/zone.service';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Zone} from '../../../zone/zone';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {filter, map, mergeMap} from 'rxjs/operators';
import {DienstService} from '../../../dienst/dienst.service';
import {Diensten} from '../../../dienst/diensten';
import {DialogService} from '../../../core/dialog/dialog.service';

@Component({
    templateUrl: './edit-client-page.component.html',
    styleUrls: ['./edit-client-page.component.scss'],
    standalone: false
})
export class EditClientPage implements OnInit {
  private clientService = inject(ClientService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private dialogService = inject(DialogService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client$: Subject<Client> = new ReplaySubject<Client>(1);
  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.clientService.getClientById$(id)),
      ).subscribe(client => this.client$.next(client));
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  navigateToMeldingen(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/meldingen`);
  }

  navigateToPrestaties(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/prestaties`);
  }

  archiveClient(client: Client): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${client.getVoornaam()} wil archiveren?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.clientService.archiveer(client.getId())),
      )
      .subscribe(archivedClient => this.client$.next(archivedClient));
  }

  unarchiveClient(client: Client): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${client.getVoornaam()} wil heractiveren?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.clientService.activeer(client.getId())),
      )
      .subscribe(activatedClient => this.client$.next(activatedClient));
  }

  onEditDienstenClicked(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/diensten/beheer`);
  }

  onCancelClicked(client: Client): void {
    this.navigateToClient(client);
  }

  onEditClicked(client: Client): void {
    this.clientService.updateClient$(client)
      .subscribe(() => this.navigateToClient(client));
  }

  private navigateToClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }
}
